import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './returnGoods.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { ReturnGoods } from "model/product/returnGoods.model";

export interface ReturnGoodsDetailsProps extends DetailsStateAndDispatchProps<ReturnGoods, 'productStatus'>,
  RouteComponentProps, StateProps, DispatchProps {
}
const ReturnGoodsDetails: FC<ReturnGoodsDetailsProps> = (props) => {
  return (
    <DetailsPage<ReturnGoods, 'productStatus'>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<ReturnGoods, 'productStatus'>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ returnGoods }: RootState) => ({
  entity: returnGoods.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ReturnGoodsDetails);
